export const getPublication = state => state.config.publication;

export const getApiHost = state => state.config.apiHost;

export const shouldRedirectAfterLogout = state => state.config.shouldRedirectAfterLogout;
